import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';

const STYLE = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

const COLUMNS = [
    'ODS CUSTOMER ID',
    'CF CUSTOMER ID',
    'SFCC CUSTOMER ID',
    'VOL CUSTOMER ID',
    'TKL CUSTOMER ID'
]

export default function CustomerIdTable({customerIds}) {
    const {
        cf_customer_id,
        ods_customer_id,
        sfcc_customer_id,
        vol_customer_id,
        tkl_customer_id,
    } = customerIds;

    return (
        <Box sx={STYLE} >
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label='invoice table'>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: 'primary.light' }}>
                            {COLUMNS.map((column) =>
                                <TableCell
                                    sx={{ fontWeight: 600 }}
                                    key={column}
                                    align='right'
                                >
                                    {column}
                                </TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableCell align="right">{ods_customer_id}</TableCell>
                        <TableCell align="right">{cf_customer_id}</TableCell>
                        <TableCell align="right">{sfcc_customer_id}</TableCell>
                        <TableCell align="right">{vol_customer_id}</TableCell>
                        <TableCell align="right">{tkl_customer_id}</TableCell>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}